import styled from 'styled-components';

const MOBILE = '768px';

export const Wrapper = styled.div`
  width: 100%;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-radius: 8px;
  font-size: 15px;
  ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.matterhorn};
  margin-bottom: 16px;
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.white};

  &::placeholder {
    color: ${({ theme }) => theme.colors.silver};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.gulfStream};
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.mercury};

  @media (max-width: ${MOBILE}) {
    display: none;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }
`;

export const Th = styled.th<{ $isActions?: boolean }>`
  padding: 14px 16px;
  text-align: ${({ $isActions }) => ($isActions ? 'center' : 'left')};
  background: ${({ theme }) => theme.colors.gulfStream};
  color: ${({ theme }) => theme.colors.white};
  font-size: 13px;
  ${({ theme }) => theme.fonts.semiBold};
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
`;

export const Tr = styled.tr<{ $even: boolean }>`
  background: ${({ theme, $even }) => ($even ? theme.colors.white : theme.colors.softGray)};

  &:hover {
    background: ${({ theme }) => theme.colors.mercury};
  }

  &:last-child td {
    border-bottom: none;
  }
`;

export const Td = styled.td<{ $isActions?: boolean }>`
  padding: 12px 16px;
  font-size: 14px;
  ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.matterhorn};
  border-bottom: 1px solid ${({ theme }) => theme.colors.mercury};
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: ${({ $isActions }) => ($isActions ? 'center' : 'left')};
`;

export const ActionsCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 32px;
  color: ${({ theme }) => theme.colors.gray};
  ${({ theme }) => theme.fonts.regular};
  font-size: 15px;
`;

export const CardList = styled.div`
  display: none;
  flex-direction: column;
  gap: 12px;

  @media (max-width: ${MOBILE}) {
    display: flex;
  }
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.mercury};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
`;

export const CardField = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  align-items: flex-start;
`;

export const CardLabel = styled.span`
  font-size: 11px;
  ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.gulfStream};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 90px;
  flex-shrink: 0;
  padding-top: 2px;
`;

export const CardValue = styled.span`
  font-size: 14px;
  ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.matterhorn};
  word-break: break-word;
`;

export const CardActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid ${({ theme }) => theme.colors.mercury};
`;

export const PaginationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 20px;
  flex-wrap: wrap;
`;

export const PaginationBtn = styled.button`
  background: ${({ theme }) => theme.colors.gulfStream};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  ${({ theme }) => theme.fonts.regular};

  &:disabled {
    background: ${({ theme }) => theme.colors.lightGray};
    color: ${({ theme }) => theme.colors.gray};
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    opacity: 0.85;
  }
`;

export const PageInfo = styled.span`
  font-size: 14px;
  ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.matterhorn};
  min-width: 120px;
  text-align: center;
`;
